var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78.2524,
    height: 78.2524,
    rx: 39.1262,
    fill: "#009812"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2694 50.7819C51.4651 49.1242 50.4253 47.9176 48.6302 48.6533L45.0892 49.9677C42.2543 51.2822 40.8418 49.9677 39.4195 47.9863L33.0436 33.4884C32.2392 31.8307 32.661 30.271 34.4561 29.5353L39.4097 27.5539C41.2047 26.8084 40.9203 25.2586 40.1159 23.6008L35.8882 15.6947C35.0839 14.0369 33.4359 13.6348 31.6409 14.3704C28.0409 15.8516 25.0687 18.1764 23.1462 21.6194C20.792 25.8275 21.9691 31.6835 22.4399 34.1456C22.9107 36.6077 24.5587 40.9237 26.6872 45.3476C28.8158 49.7814 30.6796 53.2636 32.3569 55.2352C34.0245 57.2069 38.0266 62.6019 42.9802 63.8084C47.0412 64.7893 51.4258 63.9654 55.016 62.4842C56.8111 61.7485 56.8209 60.1888 56.0165 58.5213L52.2694 50.7819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallImage);
export default __webpack_public_path__ + "static/media/CallImage.796281cd9d420b9e42f0432a723b69d0.svg";
export { ForwardRef as ReactComponent };